import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Country, Department, District, Province, ubigeoType } from '../../types/slices/ubigeoType'

const initialState: ubigeoType =
{
    status: ApiStatus.FETCHED,
    countries: [],
    countrySelected: {} as Country,
    departments: [],
    departmentSelected: {} as Department,
    provinces: [],
    provinceSelected: {} as Province,
    districts: [],
    districtSelected: {} as District,
    errorMessage: undefined,
    action: ''
}

const UbigeoSlice = createSlice({
    name: 'UbigeoSlice',
    initialState,
    reducers: {

        onFetchCountries (state, { payload }: { payload: Country[]}) {
            state.status = ApiStatus.FETCHED
            state.countries = payload
            state.errorMessage = undefined
        },
        onSetSelectedCountry (state, { payload }: { payload: Country }) {
            state.countrySelected = payload
        },
        onFetchDepartments (state, { payload }: { payload: Department[]}) {
            state.status = ApiStatus.FETCHED
            state.departments = payload
            state.errorMessage = undefined
        },
        onSetSelectedDepartment (state, { payload }: { payload: Department }) {
            state.departmentSelected = payload
        },
        onFetchProvinces (state, { payload }: { payload: Province[]}) {
            state.status = ApiStatus.FETCHED
            state.provinces = payload
            state.errorMessage = undefined
        },
        onSetSelectedProvince (state, { payload }: { payload: Province }) {
            state.provinceSelected = payload
        },
        onFetchDistricts (state, { payload }: { payload: District[]}) {
            state.status = ApiStatus.FETCHED
            state.districts = payload
            state.errorMessage = undefined
        },
        onSetSelectedDistrict (state, { payload }: { payload: District }) {
            state.districtSelected = payload
        },

        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectUbigeoState = (state: RootState) => state.UbigeoSlice
export default UbigeoSlice.reducer
export const {
    onFetchCountries,
    onSetSelectedCountry,
    onFetchDepartments,
    onSetSelectedDepartment,
    onFetchProvinces,
    onSetSelectedProvince,
    onFetchDistricts,
    onSetSelectedDistrict,
    changeStatus,
    setAction,
} = UbigeoSlice.actions
